import DOMPurify from 'dompurify';
import 'prosemirror-state';
import 'prosemirror-model';

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";
var PARKER_CLASSNAME_PREFIX = "pk";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
var classNameParkerPrefix = function(className) {
    return classNamePrefix(className, PARKER_CLASSNAME_PREFIX);
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = '.ProseMirror *,.ProseMirror :after,.ProseMirror :before{box-sizing:border-box}.ct-editor h1,.ct-editor h2,.ct-editor h3,.ct-editor h4,.ct-editor h5,.ct-editor h6,.ct-editor p,.ct-editor pre{margin:8px 0;color:#333;word-break:break-word;clear:both}.ct-editor p,.ct-editor pre{font-size:14px;line-height:22px;min-height:24px}.ct-editor h1{font-size:28px;font-weight:700;line-height:42px;min-height:42px}.ct-editor h2{font-size:24px;font-weight:700;line-height:36px;min-height:36px}.ct-editor h3{font-size:20px;font-weight:700;line-height:30px}.ct-editor h4{font-size:16px;font-weight:700;line-height:22px;min-height:24px}.ct-editor h5{font-size:14px;font-weight:700;line-height:21px;min-height:21px}.ct-editor h6{font-size:12px;font-weight:700;line-height:18px;min-height:18px}.ct-editor hr{display:block;height:1px;width:100%;border:0;background:#ccc}.ProseMirror{position:relative;word-wrap:break-word;white-space:pre-wrap;white-space:break-spaces;font-variant-ligatures:none;font-feature-settings:"liga" 0}.ProseMirror p{font-size:14px;line-height:22px;min-height:24px;margin:8px 0;color:#333;word-break:break-word;clear:both}.ProseMirror pre{white-space:pre-wrap}.ProseMirror li{position:relative}.ProseMirror-hideselection *::-moz-selection{background:transparent}.ProseMirror-hideselection ::selection{background:transparent}.ProseMirror-hideselection ::-moz-selection{background:transparent}li.ProseMirror-selectednode{outline:none}li.ProseMirror-selectednode:after{content:"";position:absolute;left:-32px;right:-2px;top:-2px;bottom:-2px;border:2px solid #8cf;pointer-events:none}.pk-view-container p{font-size:14px;line-height:22px;min-height:24px;margin:8px 0;color:#333;word-break:break-word;clear:both}';
styleInject(css_248z);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var __generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var intersectionObserverConfig = {
    rootMargin: "0px 0px 200px 0px"
};
var createIntersectionObserver = function() {
    return new IntersectionObserver(function(entries) {
        entries.filter(function(param) {
            var isIntersecting = param.isIntersecting;
            return isIntersecting;
        }).forEach(function(param) {
            var target = param.target;
            var src = target.getAttribute("data-src");
            target.setAttribute("src", src);
        });
    }, intersectionObserverConfig);
};
var EditorRender = function EditorRender(dom, param) {
    var _param_defaultValue = param.defaultValue, defaultValue = _param_defaultValue === void 0 ? "" : _param_defaultValue, _param_renders = param.renders, renders = _param_renders === void 0 ? [] : _param_renders, _param_lazyload = param.lazyload, lazyload = _param_lazyload === void 0 ? false : _param_lazyload;
    var _this = this;
    _classCallCheck(this, EditorRender);
    this.setValue = function(str) {
        if (str && typeof str === "string") {
            // 临时方案，替换className前缀，后期会修改数据存储格式
            _this.htmlString = str;
        } else {
            _this.htmlString = "";
        }
    };
    var _this1 = this;
    this.render = function() {
        var _ref = _asyncToGenerator(function(htmlString) {
            var documentFragment, $container, i;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this1.setValue(htmlString);
                        documentFragment = document.createDocumentFragment();
                        $container = document.createElement("div");
                        $container.classList.add(classNameParkerPrefix("view-container"));
                        $container.innerHTML = DOMPurify.sanitize(_this1.htmlString, {
                            ALLOW_UNKNOWN_PROTOCOLS: true
                        });
                        i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i < _this1.renders.length)) return [
                            3,
                            4
                        ];
                        if (!_this1.renders[i].preprocess) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            _this1.renders[i].preprocess($container, {
                                lazyload: _this1.lazyload,
                                containerWidth: _this1.dom.clientWidth
                            })
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        _this1.renders.forEach(function(render) {
                            if (render.fragmentCls && render.fragmentRender) {
                                Array.from($container.querySelectorAll(render.fragmentCls)).forEach(function(node) {
                                    render.fragmentRender(node, $container);
                                });
                            }
                        });
                        _this1.renders.forEach(function(render) {
                            if (render.containerRender) {
                                render.containerRender($container, {
                                    lazyload: _this1.lazyload,
                                    containerWidth: _this1.dom.clientWidth
                                });
                            }
                        });
                        documentFragment.appendChild($container);
                        _this1.clearDOM(_this1.dom);
                        _this1.dom.appendChild(documentFragment);
                        if (_this1.lazyload) {
                            _this1.intersectionObserver = createIntersectionObserver();
                            _this1.initLazyload();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(htmlString) {
            return _ref.apply(this, arguments);
        };
    }();
    this.clearDOM = function(dom) {
        dom.innerHTML = "";
    };
    this.initLazyload = function() {
        if (_this.lazyload) {
            Array.from(_this.dom.querySelectorAll("img")).forEach(function(node) {
                if (node.getAttribute("data-src")) {
                    _this.intersectionObserver.observe(node);
                }
            });
        }
    };
    this.dom = dom;
    this.renders = renders;
    this.lazyload = lazyload;
    if (!window.IntersectionObserver) this.lazyload = false;
    this.clearDOM(this.dom);
    this.render(defaultValue);
};

export default EditorRender;
//# sourceMappingURL=index.js.map
